<div class="flex flex-col gap-2" [formGroup]="form">
  <label class="truncate" [ngClass]="smallLabel() ? 'text-sm' : ''" [for]="id()">
    {{ label() | transloco }}
  </label>

  @if (isReadOnly()) {
    <input
      pInputText
      [value]="
        (form.get(fieldName())?.value?.length || 0) + ' ' + ('multiselect.selected' | transloco)
      "
      [disabled]="true"
      class="w-full"
    />
  } @else {
    <p-multiSelect
      [id]="id()"
      [formControlName]="fieldName()"
      [options]="selectTranslatedOptions()"
      optionValue="id"
      [placeholder]="placeholder() || ''"
      [filter]="hasFilterText()"
      [filterBy]="'searchText'"
      [required]="isRequired()"
      class="w-full"
      appendTo="body"
    >
      <ng-template #item let-item>
        {{ item.translations | translateDirectus }}
      </ng-template>

      <ng-template #selecteditems let-selectedOptions>
        @if (selectedOptions?.length > 0) {
          {{ selectedOptions.length }} {{ 'multiselect.selected' | transloco }}
        }
      </ng-template>
    </p-multiSelect>
  }
</div>
